import useThemeParam from "./useThemeParam";
import { useMemo } from "react";

const onboardingTexts = {
  quiz: {
    start_age_full: {
      default: {
        title: "PERSONAL FITNESS PLAN TO LOSE WEIGHT",
        description: "According to your age",
      },
      summerBody: {
        title: "PERSONAL SUMMER BODY PLAN TO GET FIT",
        description: "According to your age",
      },
      bikiniBody: {
        title: "PERSONAL BIKINI BODY PLAN TO GET FIT",
        description: "According to your age",
      },
      wallPilates: {
        title: "WALL PILATES WORKOUT PLAN",
        description: "According to your age",
      },
      notExercised: {
        title: "PERSONAL FITNESS PLAN TO LOSE WEIGHT",
        description: "Even if it’s your first workout in years",
      },
    },
    feedback_weight_goal: {
      default: {
        title:
          "No more exhausting, lengthy workouts or annoying diet restrictions!",
        description: "Personal fitness plan will help you",
      },
      summerBody: {
        title:
          "Get summer-body ready without exhausting workouts or strict diets!",
        description: "Your personalized fitness plan will help you",
      },
      bikiniBody: {
        title:
          "Get bikini-body ready without exhausting workouts or strict diets!",
        description: "Your personalized fitness plan will help you",
      },
      wallPilates: {
        title: "No more exhausting, lengthy workouts or annoying diet restrictions!",
        description: "A personal wall pilates plan will help you",
      },
      notExercised: {
        title:
          "Get back in fitness — even if you haven’t worked out in years! No more exhausting, lengthy workouts or annoying diet restrictions! ",
        description: "Your personalized fitness plan will help you",
      },
    },
    feedback_weight_goal2: {
      default: {
        title: "Transform your body with the power of mindful exercise",
        description:
          "It directly interacts with the nervous system to relieve chronic muscle tension and alleviate pent-up stress.",
      },
      summerBody: {
        title:
          "Transform your body into a summer body with the power of a personalized exercise plan!",
        description:
          "Reset your body for summer — from the inside out. Gentle exercises calm the nervous system, release tension, and help you slim down without stress.",
      },
      bikiniBody: {
        title:
          "Transform your body into a bikini body with the power of a personalized exercise plan!",
        description:
          "Reset your body for summer — from the inside out. Gentle exercises calm the nervous system, release tension, and help you slim down without stress.",
      },
      wallPilates: {
        title: "Transform your body with the power of wall pilates workouts",
        description: "No intense workouts needed. Wall pilates movements help you ease back into fitness, reduce tension, and shed stress weight — even if it’s been years since your last workout.",
      },
      notExercised: {
        title:
          "Transform your body with the power of an adjusted to your level fitness plan",
        description:
          "No intense workouts needed. Gentle movements help you ease back into fitness, reduce tension, and shed stress weight — even if it’s been years since your last workout.",
      },
    },
    fitlevel_feedback: {
      default: {
        title: "Your current fitness level overview",
      },
      summerBody: {
        title: "Your starting point for a summer-ready body",
      },
      bikiniBody: {
        title: "Your starting point for a bikini-body",
      },
      wallPilates: {
        title: "Your current fitness level overview",
      },
      notExercised: {
        title: "Your fitness comeback starts here",
      },
    },
    creating: {
      default: {
        title: "Creating your personalized plan",
      },
      summerBody: {
        title: "Creating your personalized summer-body plan",
      },
      bikiniBody: {
        title: "Creating your personalized bikini-body plan",
      },
      wallPilates: {
        title: "Creating your personalized wall pilates plan",
      },
      notExercised: {
        title: "Creating your step-by-step return to fitness",
      },
    },
    email: {
      default: {
        title: "Your personal 4-week plan to lose weight is ready",
      },
      summerBody: {
        title: "Your personalized 4-week summer-body plan is ready",
      },
      bikiniBody: {
        title: "Your 4-week bikini-body plan is ready",
      },
      wallPilates: {
        title: "Your 4-week wall pilates plan to lose weight is ready",
      },
      notExercised: {
        title: "Your personalized 4-week fitness comeback plan is ready",
      },
    },
    email_consent: {
      default: {
        title:
          "Do you want to receive emails with Weight Loss tips and our product updates?",
      },
      summerBody: {
        title:
          "Would you like to receive emails with Getting Summer Body tips and our product updates?",
      },
      bikiniBody: {
        title:
          "Would you like to receive emails with bikini body tips and our product updates?",
      },
      wallPilates: {
        title: "Would you like to receive emails with Wall Pilates tips and our latest product updates?",
      },
      notExercised: {
        title:
          "Would you like to receive emails about getting back into fitness and our product updates?",
      },
    },
    plan: {
      default: {
        title: "your 4-week customized exercise plan",
      },
      summerBody: {
        title: "your 4-week customized summer-body exercise plan",
      },
      bikiniBody: {
        title: "your 4-week customized bikini-body exercise plan",
      },
      wallPilates: {
        title: "your 4-week customized wall pilates plan",
      },
      notExercised: {
        title: "your 4-week customized fitness comeback exercise plan",
      },
    },
    payment: {
      default: {
        title: "Your tailored weight loss plan is ready!",
        description: "Find lasting relief in 10-15 min a day",
      },
      summerBody: {
        title: "Your tailored summer-body plan is ready!",
        description: "Get summer-body ready in just 15 minutes a day",
      },
      bikiniBody: {
        title: "Your tailored bikini-body plan is ready!",
        description: "Get bikini-body ready in just 15 minutes a day",
      },
      wallPilates: {
        title: "Your tailored wall pilates plan is ready!",
        description: "Rebuild your fitness in just 10–15 minutes daily",
      },
      notExercised: {
        title: "Your fitness level-based weight loss plan is ready to go!",
        description: "Rebuild your fitness in just 10–15 minutes daily",
      },
    },
  },
  somatic: {
    start_age_full: {
      default: {
        title: "Somatic exercises",
        description: "Release emotions, reduce tensions and lose weight",
      },
      cortisolDetox: {
        title: "Personal Cortisol Detox Plan",
        description: "Release emotions, reduce tensions, and lose weight",
      },
      cortisolBelly: {
        title: "Say Goodbye to Cortisol Belly",
        description: "Release emotions, reduce tensions, and lose weight",
      },
      storedEmotions: {
        title: "Somatic exercises to release stored emotions",
        description: "Unblock emotions, reduce tensions, and lose weight",
      },
      fightOrFlightMode: {
        title: "Exit fight-or-flight mode with somatic exercises",
        description: "Reset your nervous system, and lose weight",
      },
    },
    feedback_weight_goal: {
      default: {
        title:
          "No more exhausting, lengthy workouts or annoying diet restrictions!",
        description: "A personal fitness plan will help you",
      },
      cortisolDetox: {
        title:
          "No more burnout workouts or strict diets — reset your body and lower cortisol naturally.",
        description: "A personal Cortisol detox plan will help you",
      },
      cortisolBelly: {
        title:
          "No more burnout workouts or strict diets — reset your body and іay goodbye to cortisol belly.",
        description: "A personal Cortisol Belly Reset Plan will help you",
      },
      storedEmotions: {
        title:
          "No more burnout workouts or strict diets — release stored emotions and reset your body.",
        description:
          "Your personal Stored Emotions Release Plan to calm your system and support lasting change to help you",
      },
      fightOrFlightMode: {
        title:
          "No more burnout workouts or strict diets — calm your nervous system and get out of fight-or-flight mode.",
        description:
          "Your personal Fight-or-Flight Exit Plan to restore balance and support long-term well-being to help you",
      },
    },
    feedback_weight_goal2: {
      default: {
        title: "Transform your body with the power of mindful exercise",
        description:
          "It directly interacts with the nervous system to relieve chronic muscle tension and alleviate pent-up stress.",
      },
      cortisolDetox: {
        title: "Transform your body with a cortisol detox exercise",
        description:
          "Mindful exercise calms your nervous system, eases muscle tension, and helps release built-up cortisol and stress.",
      },
      cortisolBelly: {
        title: "Transform your body with an anti-cortisol belly exercise",
        description:
          "Mindful exercise calms your nervous system, eases muscle tension, and helps release built-up cortisol and stress.",
      },
      storedEmotions: {
        title: "Transform your body with the power of mindful exercise",
        description:
          "It directly interacts with the nervous system to relieve chronic muscle tension and alleviate pent-up stress.",
      },
      fightOrFlightMode: {
        title: "Transform your body with the power of mindful exercise",
        description:
          "It directly interacts with the nervous system to relieve chronic muscle tension and alleviate pent-up stress.",
      },
    },
    fitlevel_feedback: {
      default: {
        title: "Your current fitness level overview",
      },
      cortisolDetox: {
        title: "Your starting point for stress relief",
      },
      cortisolBelly: {
        title: "Your starting point for stress relief",
      },
      storedEmotions: {
        title: "Your starting point for stress relief",
      },
      fightOrFlightMode: {
        title: "Your starting point for stress relief",
      },
    },
    creating: {
      default: {
        title: "Creating your personalized plan",
      },
      cortisolDetox: {
        title: "Creating your personalized Cortisol Detox plan",
      },
      cortisolBelly: {
        title: "Creating your personalized Cortisol Belly Reset plan",
      },
      storedEmotions: {
        title: "Creating your personalized plan to unblock stored emotions",
      },
      fightOrFlightMode: {
        title: "Creating your personalized plan to exit fight-or-flight mode ",
      },
    },
    email: {
      default: {
        title: "Your 4-week Somatic exercise plan is ready",
      },
      cortisolDetox: {
        title: "Your 4-week Cortisol Detox plan is ready",
      },
      cortisolBelly: {
        title: "Your 4-week Cortisol Belly Relief plan is ready",
      },
      storedEmotions: {
        title: "Your 4-week Stored Emotions Release Plan is ready",
      },
      fightOrFlightMode: {
        title: "Your 4-week Exit Fight-or-Flight Mode Plan is ready",
      },
    },
    email_consent: {
      default: {
        title:
          "Do you want to receive emails with Somatic exercise tips and our product updates?",
      },
      cortisolDetox: {
        title:
          "Would you like to receive emails with Cortisol Detox tips and our product updates?",
      },
      cortisolBelly: {
        title:
          "Would you like to receive emails with Cortisol Belly Relief tips and our product updates?",
      },
      storedEmotions: {
        title:
          "Would you like to receive emails with tips on releasing stored emotions and our product updates?",
      },
      fightOrFlightMode: {
        title:
          "Would you like to receive emails with tips on Exiting Fight-or-Flight Mode and our product updates?",
      },
    },
    plan: {
      default: {
        title: "your 4-week customized Somatic Exercise Plan",
      },
      cortisolDetox: {
        title: "your 4-week Cortisol Detox Plan",
      },
      cortisolBelly: {
        title: "your 4-week Cortisol Belly Relief Plan",
      },
      storedEmotions: {
        title: "your 4-week Plan to Release Stored Emotions",
      },
      fightOrFlightMode: {
        title: "your 4-week Plan to Exit Fight-or-Flight mode",
      },
    },
    payment: {
      default: {
        title: "Your Somatic Exercise Plan is ready!",
      },
      cortisolDetox: {
        title: "Your Cortisol Detox Plan is ready!",
      },
      cortisolBelly: {
        title: "Your Cortisol Belly Relief Plan is ready!",
      },
      storedEmotions: {
        title: " Your Stored Emotions Release Plan is ready!",
      },
      fightOrFlightMode: {
        title: "Your Exit Fight‑or‑Flight Plan is ready!",
      },
    },
  },
};

export function useOnboardingTexts() {
  const { theme, block } = useThemeParam();

  const texts = useMemo(() => {
    if (!block) return onboardingTexts.quiz;
    return onboardingTexts[block] || onboardingTexts.quiz;
  }, [block]);

  return {
    getSectionText(sectionName) {
      const section = texts[sectionName];
      if (!section) return texts.default?.[sectionName] || {};
      return section[theme] || section.default || {};
    },
  };
}
